var heading1 = {
  "fontFamily": "\"Helvetica Neue\", Helvetica, sans-serif",
  "fontWeight": "600",
  "fontSize": "0.8125rem",
  "lineHeight": "1.125rem",
  "textTransform": "uppercase"
};

export { heading1 };
